export enum ParameterInputPrefix {
  ENV = 'env.',
}
